import { useEffect, useState} from 'react'
import { useDispatch,useSelector} from 'react-redux'
import Portal from '../API/Portal.js'
import { setExamLink, setExamType,setFormList,setCompletedForms,setTriageScore,setExamPassword,resetState} from '../redux/ExamSlice.js';
import { setForms } from '../redux/UserSlice';
import {TableContainer,Table,TableBody,TableRow,TableHead,TableCell} from '../styles/CheckupStyle.js'
import LinkExam from './LinkExam';
import {Text,SubmitButton,LoadingIcon,Container} from '../styles/style.js'
import { FormInfo } from './forms/FormInfo.js';
import WriteDB from '../API/WriteDB.js';

const writeDB = new WriteDB()
const portal = new Portal();
export default function Checkup(){
    const dispatch = useDispatch();
    const [showExam, setShowExam] = useState(false)
    const [submitText,setSubmitText] = useState('Start')
    const [loading,setLoading] = useState(true)
    const [showResult,setShowResults] = useState(false)
    const forms = useSelector((state) => state.user.forms)
    
    useEffect(()=>{
        async function fetchSelfCheckup(){
            var response = await portal.readExams();
            for(let i = 0;i < response.length;i++){
                if(response[i].type === 'Self Checkup'){
                    dispatch(setExamLink(response[i].link))
                    dispatch(setCompletedForms(response[i].completedForms === undefined ? [] : response[i].completedForms))
                    dispatch(setExamType(response[i].type));
                    dispatch(setTriageScore(response[i].tempTriage === undefined ? 0 : response[i].tempTriage))
                    dispatch(setFormList(response[i].formList))
                    dispatch(setExamPassword(response[i].password))
                    setShowExam(true);
                }
            }
            setLoading(false)
        }
        fetchSelfCheckup()
    },[dispatch])

    async function createSelfCheckup(){
        setSubmitText('Creating');
        var response = await portal.selfCheckup();
        dispatch(setExamLink(response.link))
        dispatch(setCompletedForms(response.completedForms === undefined ? [] : response.completedForms))
        dispatch(setExamType(response.type));
        dispatch(setTriageScore(response.tempTriage === undefined ? 0 : response.tempTriage))
        dispatch(setFormList(response.formList))
        dispatch(setExamPassword(response.password))
        setShowExam(true);
        setSubmitText('Start');
    }

    async function handleExit(){
        await writeDB.deleteLink();
        dispatch(resetState())
        setLoading(true)
        var response  = await portal.readForms();
        if(response !== 'Read Forms Error'){
            dispatch(setForms(response))
        }
        setLoading(false)
        setShowResults(true)
    }

    function getResults(){
        for(let i = 0;i < forms.length;i++){
            if(forms[i].examType === 'Self Checkup'){
                return (
                    <TableRow>
                        <TableCell>{forms[i][FormInfo.WHO5.name].score}</TableCell>
                        <TableCell>{forms[i][FormInfo.PHQ9.name].score}</TableCell>
                        <TableCell>{forms[i][FormInfo.GAD.name].score}</TableCell>
                    </TableRow>
                )
            }
        }

        return [];
    }

    if(loading){
        return(
            <Container>
                <LoadingIcon className="fas fa-spinner"></LoadingIcon>
            </Container>
        )
    }else{
        return(
            <>
                {!showExam && !showResult &&
                   <>
                        <Text>Placeholder Text</Text>
                        <SubmitButton onClick={()=>{createSelfCheckup()}}>{submitText}</SubmitButton>
                   </>
                }

                {showExam && !showResult &&
                    <LinkExam type='clientPortal' examDone={()=>{handleExit()}}></LinkExam>
                }

                {showResult && 
                    <TableContainer>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableHead>{FormInfo.WHO5.name}</TableHead>
                                    <TableHead>{FormInfo.PHQ9.name}</TableHead>
                                    <TableHead>{FormInfo.GAD.name}</TableHead>
                                </TableRow>
                                {getResults()}
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </>
        )
    }
}